import { render, staticRenderFns } from "./creatOrder.vue?vue&type=template&id=486ec374&"
import script from "./creatOrder.vue?vue&type=script&lang=js&"
export * from "./creatOrder.vue?vue&type=script&lang=js&"
import style0 from "./creatOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports